import React, { useContext } from "react";
import "./restaurent.css";
// import Rating from "../rating/Rating";
import { foodTypes, isRestaurentAvailable } from "../../functions/mini_func.js";
import { useNavigate } from "react-router-dom";
import { errorToast } from "../../functions/mini_func.js";
import { useLocation } from "react-router-dom";
import { Clock, MapPin } from "lucide-react";

const Rating = ({ rating, totalRatings }) => {
  return rating != "0" ? (<div className='rating-container !text-xs' >
    <h4>{parseFloat(rating).toPrecision(2)}</h4>
    <span >&#9733;</span>
    {
      totalRatings != "0" && <div>({totalRatings})</div>
    }

  </div>) : <div></div>
}

const Restaurent = ({ restItem }) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const restIDParam = queryParams.get("restID");
  const storeType = queryParams.get("storeType");
  console.log("<-- restID params ---->", restIDParam, "<-------->");
  const restID = restIDParam ? restIDParam.split("<")[0] : null;

  console.log({ restItem });

  const navigate = useNavigate();

  const openRestPage = () => {
    if (isRestaurentAvailable(restItem)) {
      const queryString = new URLSearchParams({
        // restID : restID,
        storeID: restItem.dbID,
        storeType: storeType,
      }).toString();
      navigate(`/restaurent?${queryString}`);
    } else {
      errorToast(
        "Service Unavailable",
        `Currently ${restItem.name} is not accepting any orders. `
      );
    }
  };

  const isAvailable = isRestaurentAvailable(restItem);

  console.log("rest information : ", restItem);
  return (
    <div
      onClick={() => openRestPage()}
      className={`restuarent-container !my-4 ${!isAvailable ? "unavailable" : ""
        }`}
    >
      <div className="rest-image-wrapper !mt-1.5">
        <img
          className="rest-image-container"
          src={restItem.image}
          alt={restItem.name}
          width="120px"
          height="100px"
        />
        {!isAvailable && (
          <div className="unavailable-overlay">
            <Clock size={16} />
            <span>Closed</span>
          </div>
        )}
      </div>
      <div className="!flex !flex-col !justify-between !h-full">
        <div>
          <h3 className="font-semibold !mb-0">{restItem.name}</h3>
          <span className="rest-food-types !text-xs">
            {foodTypes(restItem)}
          </span>
        </div>
        <div className="rest-meta ">
          <Rating
            rating={restItem.restRating}
            totalRatings={restItem.totalRatings ?? 0}
          />
          {restItem.distance && (
            <div className="rest-distance">
              <MapPin size={12} />
              <span>{restItem.distance.toFixed(1)} km</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Restaurent;
